import { useTranslation } from "react-i18next";
import { mainSiteUrl } from "@/mocks/categories";

interface HeroProps {
  query: string;
  onQueryChange: (value: string) => void;
}

const heroImage =
  "https://readdy.ai/api/search-image?query=An%20abstract%20editorial%20background%20of%20soft%20flowing%20silk%20fabric%20in%20warm%20terracotta%20amber%20sage%20green%20and%20cream%20tones%20arranged%20in%20gentle%20waves%20with%20elegant%20negative%20space%20and%20soft%20diffused%20natural%20light%20no%20text%20no%20people%20premium%20minimal%20artistic%20composition%20high%20detail&width=1600&height=900&seq=usfans-hero&orientation=landscape&nocache=true";

export default function Hero({ query, onQueryChange }: HeroProps) {
  const { t } = useTranslation();

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0 h-full w-full">
        <img
          src={heroImage}
          alt="USFans Spreadsheet fashion finds"
          title="USFans Spreadsheet product finds"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/45"></div>
      </div>

      <div className="relative z-10 mx-auto flex min-h-[560px] w-full max-w-4xl flex-col items-center justify-center px-4 py-24 text-center md:min-h-[640px] md:px-6 md:py-32">
        <span className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-xs font-medium text-background-50 backdrop-blur-sm">
          <span className="w-3.5 h-3.5 flex items-center justify-center">
            <i className="ri-sparkling-2-line"></i>
          </span>
          {t("hero.badge")}
        </span>

        <h1 className="mt-6 max-w-3xl font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl">
          {t("hero.title")}
        </h1>

        <p className="mt-5 max-w-2xl text-base leading-relaxed text-background-50/90 md:text-lg">
          {t("hero.subtitle")}
        </p>

        <div className="mt-8 w-full max-w-xl">
          <div className="flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/95 px-4 py-3 backdrop-blur-sm">
            <span className="w-5 h-5 flex items-center justify-center text-foreground-500">
              <i className="ri-search-line text-lg"></i>
            </span>
            <input
              type="text"
              value={query}
              onChange={(e) => onQueryChange(e.target.value)}
              placeholder={t("hero.search")}
              className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
            />
          </div>
        </div>

        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            {t("hero.cta1")}
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap rounded-md bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-950 transition-colors hover:bg-background-100"
          >
            {t("hero.cta2")}
          </a>
        </div>
      </div>
    </section>
  );
}